import { createPluginFactory } from "@udecode/plate";
import withOdoEditorOverrides from "./withOdoEditorOverrides.js";
export const createOdoEditorPlugin = createPluginFactory({
    key: "odo-editor",
    withOverrides: withOdoEditorOverrides,
});
